// Mock data pentru formular - va fi înlocuit cu date reale în backend
export const mockFormData = {
  // Secțiunea pentru informare consumator
  consumerInformation: {
    acceptInformation: false,
    acceptDataProcessing: false,
    acceptTerms: false
  },

  // Informare OUG 52
  oug52Information: {
    acceptInformation: false,
    acceptDataProcessing: false,
    acceptTerms: false
  },

  // Informare GDPR
  gdprInformation: {
    gdprInformationRead: false,
    gdprConsentProcessing: false,
    gdprRightsUnderstood: false
  },
  creditType: {
    selectedTypes: ["Credit Ipotecar"]
  },
  creditInfo: {
    creditValue: "200000",
    currency: "LEI",
    creditPeriod: "25",
    periodUnit: "ani",
    propertyPrice: "250000",
    additionalGuarantees: false,
    collateralDeposit: false,
    familyTransaction: false  // Nou câmp pentru tranzacție în familie
  },
  propertyInfo: {
    propertyType: "Apartament",
    energyClass: "B",
    ownsProperty: false,
    ownedProperty: false,
    willLiveInProperty: true
  },
  personalInfo: {
    firstName: "",
    lastName: "",
    birthDate: "",
    cnp: "",
    idType: "CI",
    idSeries: "",
    idNumber: "",
    idIssuer: "",
    idIssueDate: "",
    idExpiryDate: "",
    citizenship: "Română",
    maritalStatus: "Necăsătorit",
    education: "Superioare",
    childrenCount: "0",
    sex: "",
    // Adresa domiciliu - structurata
    domCounty: "",
    domCity: "",
    domStreet: "",
    domNumber: "",
    domBlock: "",
    domStaircase: "",
    domFloor: "",
    domApartment: "",
    domPostalCode: "",
    // Adresa resedinta - structurata
    resCounty: "",
    resCity: "",
    resStreet: "",
    resNumber: "",
    resBlock: "",
    resStaircase: "",
    resFloor: "",
    resApartment: "",
    resPostalCode: "",
    phone: "",
    email: "",
    motherMaidenName: "",
    livingCondition: "Cu părinții",
    isPoliticallyExposed: false
  },
  // Noua secțiune pentru persoane afiliate bănci
  bankAffiliatedPersons: {
    isBankFamilyMember: false,
    bankName: "",
    employeeName: "",
    hasGroupRelations: false,
    groupRelationBank: "",
    isAffiliatedPerson: false,
    affiliatedBank: ""
  },
  employerInfo: {
    companyName: "",
    cui: "",
    companyPhone: "",
    companyType: "Privat român",
    employeeCount: "<20",
    empCounty: "",
    empCity: "",
    empStreet: "",
    empNumber: "",
    empBlock: "",
    empStaircase: "",
    empFloor: "",
    empApartment: "",
    empPostalCode: "",
    empAddrFull: "",
    companyAddress: "",
    contractType: "Nedeterminată",
    contractPeriod: "",
    hireDate: "",
    totalSeniority: "",
    profession: "",
    currentPosition: "",
    caenCode: "",
    hasInterruptions: false,
    interruptions: ""
  },
  income: {
    incomes: [
      { type: "Salariu perioada nedeterminata", value: "" }
    ],
    mealVouchers: "",
    otherSources: "",
    foreignIncome: false,
    ownCompanyIncome: false,
    confirmedSingleIncome: false,
    lastYearAvgIncome: "",
    incomeJustification: ""
  },
  debts: [],
  // Secțiunea pentru codebitori
  codebitors: {
    hasCodebitors: false,
    codebitorsList: []
  },
  // Secțiunea pentru declarația consumator
  consumerDeclaration: {
    consumerName: "",
    consumerAddress: "",
    reduceReflectionPeriod: false,
    reducedDays: "",
    noReductionReflectionPeriod: false,
    communicateByEmail: false,
    communicateInWriting: false,
    finalDataAccuracy: false,
    finalDataProcessingConsent: false,
    finalNoFirmOffer: false,
    consumerSignature: "",
    signatureDate: new Date().toISOString().split('T')[0]
  },
  // Vechea secțiune acorduri (păstrată pentru compatibilitate)
  agreements: {
    dataAccuracy: false,
    dataProcessing: false,
    noFirmOffer: false,
    signature: "",
    signatureDate: new Date().toISOString().split('T')[0]
  }
};

// Funcție pentru a genera structura unui codebitor
export const createEmptyCodebitor = () => ({
  id: Date.now(),
  relationship: "",
  personalInfo: {
    firstName: "",
    lastName: "",
    sex: "",
    birthDate: "",
    cnp: "",
    idType: "CI",
    idSeries: "",
    idNumber: "",
    idIssuer: "",
    idIssueDate: "",
    idExpiryDate: "",
    citizenship: "Română",
    maritalStatus: "Necăsătorit",
    education: "Superioare",
    childrenCount: "0",
    // Adresă Domiciliu (structurată)
    domCounty: "",
    domCity: "",
    domStreet: "",
    domNumber: "",
    domBlock: "",
    domStaircase: "",
    domFloor: "",
    domApartment: "",
    domPostalCode: "",
    // Adresă Reședință (structurată)
    resCounty: "",
    resCity: "",
    resStreet: "",
    resNumber: "",
    resBlock: "",
    resStaircase: "",
    resFloor: "",
    resApartment: "",
    resPostalCode: "",
    phone: "",
    email: "",
    motherMaidenName: "",
    livingCondition: "Cu părinții",
    isPoliticallyExposed: false
  },
  employerInfo: {
    companyName: "",
    cui: "",
    companyAddress: "",
    companyType: "Privat român",
    employeeCount: "<20",
    contractType: "Nedeterminată",
    contractPeriod: "",
    hireDate: "",
    totalSeniority: "",
    profession: "",
    currentPosition: "",
    caenCode: "",
    hasInterruptions: false,
    interruptions: ""
  },
  income: {
    incomes: [
      { type: "Salariu perioada nedeterminata", value: "" }
    ]
  },
  debts: []
});

// Opțiuni pentru dropdown-uri
export const creditTypes = [
  "Credit Ipotecar",
  "Credit Nevoi Personale", 
  "Refinanțare Credit Nevoi Personale",
  "Refinanțare Credit Ipotecar",
  "Credit Noua Casă",
  "Credit Imobiliar",
  "Credit de construcție",
  "Achiziție teren",
  "Credit Auto",
  "Card de Credit"
];

export const propertyTypes = [
  "Apartament",
  "Casă", 
  "Teren",
  "Alte tipuri"
];

export const energyClasses = ["A", "B", "C", "D", "Necunoscut"];

export const maritalStatuses = [
  "Necăsătorit",
  "Căsătorit", 
  "Divorțat",
  "Văduv",
  "Partener de viață"
];

export const educationLevels = [
  "Primare",
  "Liceu",
  "Postliceal", 
  "Superioare",
  "Master",
  "Doctorat"
];

export const livingConditions = [
  "Proprietar",
  "Cu părinții",
  "În chirie",
  "Cu terți"
];

export const companyTypes = [
  "Stat",
  "Privat român",
  "Privat străin", 
  "Mixt"
];

export const employeeCounts = [
  "<20",
  "20-250",
  ">250",
  "Multinațională"
];

export const contractTypes = [
  "Nedeterminată",
  "Determinată",
  "Contract colaborare",
  "PFA"
];

export const incomeTypes = [
  "Salariu perioada nedeterminata",
  "Salariu perioada determinata",
  "Sporuri",
  "Bonusuri cu caracter permanent si continuitate",
  "Spor trimestrial",
  "Spor anual",
  "Comision lunar",
  "Comision trimestrial",
  "Comision Anual",
  "Norma de Hrana",
  "Bonuri de masa",
  "Pensie",
  "PFA (Profesii Liberale)",
  "PFA (Activitati independente)",
  "Dividende",
  "Drepturi de proprietate Intelectuala (Drepturi de autor)",
  "Chirii",
  "Venit Marinar",
  "Pensii de invaliditate Nerevizuibile",
  "Pensie de invaliditate Revizuibila",
  "Indemnizatie crestere copil",
  "Salariu din straintate",
  "Venituri din straintate",
  "Alte Venituri"
];

export const debtCreditTypes = [
  "Ipotecar",
  "Nevoi Personale",
  "Leasing",
  "Card de Credit",
  "Credit de consum",
  "Alte tipuri"
];

export const currencies = ["LEI", "EUR", "USD"];

export const relationshipTypes = [
  "Soț/Soție",
  "Frate/Soră",
  "Părinte/Copil",
  "Prieten",
  "Asociat/Colaborator",
  "Altă rudă",
  "Altul"
];

export const romanianBanks = [
  "BCR",
  "BRD",
  "Banca Transilvania",
  "Raiffeisen Bank",
  "UniCredit Bank",
  "ING",
  "Garanti Bank",
  "CEC Bank",
  "Intesa Sanpaolo / First Bank",
  "Exim Bank",
  "ProCredit Bank",
  "Patria Bank",
  "Nexent Bank / Credit Europe Bank",
  "Libra Bank",
  "Alta Banca"
];